import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverPtaQuickInfo extends Layout {
    panelQuickInfo: Panel;
    sourceDriverInfo: DataSource;
    textboxContactmobilePhone: Textbox;
    textboxContactname: Textbox;
    textboxContactphone: Textbox;
    textboxFirstName: Textbox;
    textboxFullName: Textbox;
    textboxId: Textbox;
    textboxLastHomeDate: Textbox;
    textboxNextHomeDate: Textbox;
}
